module.exports = __webpack_public_path__ + "img/icon-dashboard.cfd3f62e.png";